import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";

class Component_record_drag_and_drop_list extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_drag_and_drop_list">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Component Drag and Drop List</h2>
              <p>
                The drag and drop list component is based on the{" "}
                <PageLink
                  to="/Interface/component_search_results"
                  text="search_results"
                />{" "}
                component. The drag and drop component supports custom events
                on_change_eval and on_click_eval. Using the event.items object
                you can write code that changes or saves the items list. If you
                plan to dynamically change the items using on_change_eval you
                will need to set the list layout to dynamic.
              </p>

              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={true}
                search={true}
              />
              <InterfaceProperties
                type={"record_drag_and_drop_list"}
                name={"drag and drop list"}
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                sourceUrl={true}
                button={true}
                properties={[
                  {
                    property: "search_outputs",
                    description:
                      "Search output sets the database fields returned by a results request.",
                    defaults:
                      '["text_first_name", "text_last_name", "text_job_title", "long_age", "text_address"] default []',
                  },
                  {
                    property: "search_list_layout",
                    description:
                      "List layout defines the structure of the search resutls. See below for more details.",
                    defaults: "{ ... }",
                  },
                  {
                    property: "source_query_eval",
                    description:
                      "The source query eval allows you to convert a JSON string into an ElasticSearch query. This is useful for running automated queries with dynamic values. ",
                    defaults:
                      '"{ ... }",  "{ \\"term\\": { \\"text_status\\": \\"won\\" } }" default is ""',
                  },
                  {
                    property: "search_show",
                    description: "Turns on a quick text search field.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "on_click_eval",
                    description: "Allows you to write save order code.",
                    defaults: '"console.log(event.items)" default is ""',
                  },
                  {
                    property: "multi_select",
                    description:
                      "Enables Ctrl and Shift for multiple item selection.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "on_change_eval",
                    description:
                      "User drag and drop change order triggered event.",
                    defaults: '"console.log(event.items)" default is ""',
                  },
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Drag and Drop List Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Drag and Drop List</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_drag_and_drop_list"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#0288D1"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_position"</span>:{" "}
                  <span className="jsonY">"right"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_name"</span>:{" "}
                  <span className="jsonY">"Save order"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"buttom_width"</span>:{" "}
                  <span className="jsonP">140</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_show"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">"console.log(event.items)"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"on_change_eval"</span>:{" "}
                  <span className="jsonY">"console.log(event.items)"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"my_search_group"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_output"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"text_subject"</span>
                </div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"source_sort"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"_score"</span>,
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">
                    "object_created_by.date_created"
                  </span>
                  : &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonY">"desc"</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"search_list_layout"</span>: &#123;
                </div>

                <div className="i2">
                  <span className="jsonG">"data_dynamic"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"containers"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"top"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"width"</span>:{" "}
                  <span className="jsonY">"fl100"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"row"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"components"</span>: &#123;
                </div>
                <div className="i5">
                  <span className="jsonG">"id"</span>: &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"id"</span>,
                </div>
                <div className="i6">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i5">&#125;,</div>
                <div className="i5">
                  <span className="jsonG">"subject"</span>: &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_subject"</span>,
                </div>
                <div className="i6">
                  <span className="jsonG">"bold"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i6">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i5">&#125;</div>
                <div className="i4">&#125;</div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_drag_and_drop_list;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_drag_and_drop_list.js